import Logo from '../assets/logo'
import IconComponent from '../assets/index'

const headerControl = props => {
  const { customerName, username, privateMessagesUnreadCount, privateMessagesUrl, logoutUrl } = props

  return (
    <header class='global-header'>
      <div class='global-header__left-side'>
        <a class='global-header__logo-link' href='/'>
          <Logo
            customClass='global-header__logo'
          />
        </a>
        <p class='global-header__motto'>
          proudly working for&nbsp;
          <span class='global-header__motto-customer'>{customerName}</span>
        </p>
      </div>
      <div class='global-header__right-side'>
        <p class='global-header__username'>{username}</p>
        <a class='global-header__user-log-out qa-header-user-log-out' href={logoutUrl}>(logout)</a>
        <a class='global-header__private_messages' href={privateMessagesUrl}>
          <span class='global-header__private_messages_counter'>{privateMessagesUnreadCount}</span>
          <IconComponent
            icon='email'
            customClass='global-header__private_messages_icon'
            width='16'
            height='16'
          />
        </a>
      </div>
    </header>
  )
}

export default headerControl
